<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <!--<div v-if="isLoading" class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <div v-if="deletedItem" class="alert alert-success">{{ deletedItem['name'] }} {{$t('notifications.deleted')}}</div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link :to="{ name: 'EXSBBatchNumberCreate' }" class="btn btn-primary">{{$t('buttons.create')}}</router-link>
            </b-col>
          </b-row>
          <b-card>
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.exsbbatchnumber.list.title')}}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <Loader v-if="isLoading" size="lg"></Loader>
              <template v-else>
                <div v-if="items.length > 0">
                  <table class="table table-sm table-striped table-hover">
                    <thead>
                    <tr>
                      <th>{{$t('views.exsbbatchnumber.list.name')}}</th>
                      <th colspan="1" />
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                            v-for="item in items"
                            :key="item['@id']">
                      <td>
                        {{ item['name'] }}
                      </td>
                      <!--                    <td>-->
                      <!--                      <router-link-->
                      <!--                              v-if="item"-->
                      <!--                              :to="{name: 'EXSBBatchNumberShow', params: { id: item['@id'] }}">-->
                      <!--                        {{ item['periodType'].name }}-->
                      <!--                      </router-link>-->
                      <!--                    </td>-->
                      <td>
                        <router-link :to="{name: 'EXSBBatchNumberUpdate', params: { id: item['@id'] }}" class="float-right">
                          <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" /></router-link>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <p v-else>{{ $t('views.exsbbatchnumber.list.noBatchNumbers') }}</p>
                <div v-if="view">
                  <pagination
                    :view="view"
                    @getPage="getPage($event)"
                  ></pagination>
                </div>
              </template>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },

  computed: mapGetters({
    deletedItem: 'exsbbatchnumber/del/deleted',
    error: 'exsbbatchnumber/list/error',
    items: 'exsbbatchnumber/list/items',
    isLoading: 'exsbbatchnumber/list/isLoading',
    view: 'exsbbatchnumber/list/view'
  }),

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBBatchNumberList')
  },

  created () {
    this.getPage()
    this.channelBusinessBatchNumbers = this.$store.state.Pusher.subscribe('e_x_s_b_batch_numbers')
    this.channelBusinessBatchNumbers.bind('e_x_s_b_batch_numbers', data => {
      this.getPage()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_batch_numbers')
  },

  methods: mapActions({
    getPage: 'exsbbatchnumber/list/default'
  })
}
</script>
